import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {UserService} from '../_services';
import {LoadingService} from '../_services/loading.service';
import {Router} from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: UserService,
              private router: Router,
              private load: LoadingService) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 400 || err.statusText === 'Unauthorized') {
          this.load.hide();
          this.authenticationService.logout();
          this.router.navigate(['./map']);
        }
        const error = err.error;
        // alert(error);
        return throwError(error);
      })
    );
  }
}
